class AccordionMenu {
  constructor(elem) {
    this.elem = elem[0];
    this.expandIcons = this.elem.querySelectorAll("i");
    this.animationFrame;
    this.height = 0;
    this.duration = 300;
    this.bindEvents();
  }

  bindEvents() {
    this.expandIcons.forEach((icon) => {
      icon.addEventListener("click", (e) => {
        icon.classList.toggle("active");
        const listIsOpen = icon.classList.contains("active");
        const contentUL = icon.parentNode.nextElementSibling;
        const childIcons = contentUL.querySelectorAll("i");

        if (contentUL) {
          contentUL.classList.add("active");
          this.height =
            contentUL.offsetHeight !== 0 ? contentUL.offsetHeight : this.height;

          if (listIsOpen) {
            contentUL.classList.remove("active");
            icon.classList.remove("closed");
            this.animateUL(contentUL, this.height, true);
            icon.setAttribute("aria-expanded", "true");
            contentUL.setAttribute("aria-expanded", "true");

            childIcons.forEach((childIcon) => {
              if (childIcon.classList.contains("active")) {
                childIcon.setAttribute("aria-expanded", "true");
                childIcon.parentNode.nextElementSibling.setAttribute(
                  "aria-expanded",
                  "true"
                );
              }
            });
          } else {
            icon.classList.add("closed");
            icon.setAttribute("aria-expanded", "false");
            contentUL.setAttribute("aria-expanded", "false");

            childIcons.forEach((childIcon) => {
              childIcon.classList.remove("closed");
              childIcon.setAttribute("aria-expanded", "false");
              childIcon.parentNode.nextElementSibling.setAttribute(
                "aria-expanded",
                "false"
              );
            });
            this.animateUL(contentUL, 0, false);
          }
        }
      });
    });
  }

  animateUL(element, targetHeight, open) {
    let currentHeight = element.offsetHeight;

    const speed =
      (open ? targetHeight : currentHeight) / (this.duration / 16.67);

    open && element.classList.add("active");

    const step = () => {
      if (currentHeight !== targetHeight) {
        currentHeight = open ? currentHeight + speed : currentHeight - speed;

        if (
          (open && currentHeight + speed > targetHeight) ||
          (!open && currentHeight - speed < targetHeight)
        ) {
          currentHeight = targetHeight;
          !open && element.classList.remove("active");
        }

        element.style.height = currentHeight + "px";
        this.animationFrameOpen = requestAnimationFrame(step);
      } else {
        cancelAnimationFrame(this.animationFrame);
        element.style.height = "auto";
      }
    };
    this.animationFrame = requestAnimationFrame(step);
  }
}

export default AccordionMenu;
